(function (angular) {
	'use strict';

	var repeatInvestmentUpgradePromptObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			'amount': '=?',
			'amountOptions': '<?',
			'currentServiceLevel': '<?',
			'isAboveUpgradeThreshold': '<?',
			'nextServiceLevel': '<?',
			'repeatInvestmentAmount': '<?'
		},
		controller: [
			'$filter',
			'$scope',
			'APP_BASE_PATH',
			'mixpanelFactory',
			'STATIC_BASE_PATH',
			RepeatInvestmentUpgradePromptFunction
		],
		controllerAs: 'repeatInvestmentUpgradePrompt'
	};

	angular
		.module('serviceLevelModule')
		.component('repeatInvestmentUpgradePrompt', repeatInvestmentUpgradePromptObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/service-level/repeat-investment-upgrade-prompt.html';
	}

	function RepeatInvestmentUpgradePromptFunction(
		$filter,
		$scope,
		APP_BASE_PATH,
		mixpanelFactory,
		STATIC_BASE_PATH
	) {
		var repeatInvestmentUpgradePrompt = this;

		repeatInvestmentUpgradePrompt.setAmountNeededToUpgrade = function() {
			var minAmountNeededToUpgrade = $filter('filter')(repeatInvestmentUpgradePrompt.amountOptions, {'isMinToUpgrade': true}, true)[0];
			if(angular.isDefined(minAmountNeededToUpgrade)) {
				repeatInvestmentUpgradePrompt.amount = minAmountNeededToUpgrade;
			} else {
				$scope.$emit('repeatInvestmentUpgradePrompt:setCustomAmountToUpgradeAmount', repeatInvestmentUpgradePrompt.nextServiceLevel.amountNeededToUpgrade);
			}

			mixpanelFactory.track('Repeat Investment Upgrade Prompt Clicked', {
				'Amount': repeatInvestmentUpgradePrompt.amount.value,
				'Next Service Level': repeatInvestmentUpgradePrompt.nextServiceLevel.name
			});
		};

		repeatInvestmentUpgradePrompt.$onInit = function() {
			repeatInvestmentUpgradePrompt.appBasePath = APP_BASE_PATH;
			repeatInvestmentUpgradePrompt.cloudFrontUrl = STATIC_BASE_PATH;

			mixpanelFactory.track('Repeat Investment Upgrade Prompt Shown', {
				'Is Above Upgrade Threshold': repeatInvestmentUpgradePrompt.isAboveUpgradeThreshold,
				'Next Service Level': repeatInvestmentUpgradePrompt.nextServiceLevel.name
			});
		};
	}
})(window.angular);